import React from 'react';
import styled from '@benzinga/themetron';
import { Block } from '../Block';
import { BlockComponentProps } from '../Block';
import classNames from 'classnames';

export interface CoreColumnProps {
  block: any;
  campaigns: any;
  getBlock?: (props: BlockComponentProps) => any;
}

export const CoreColumn: React.FC<CoreColumnProps> = ({ block, campaigns, getBlock }) => {
  const className = block.attrs?.className;
  return (
    <Container
      className={classNames('wp-block-column', { [`${className}`]: !!className })}
      style={{
        flexBasis: block.attrs.width ?? null,
      }}
    >
      {block.innerBlocks?.map((inner_block: any, i: number) => {
        return <Block block={inner_block} campaigns={campaigns} getBlock={getBlock} key={`${i}`} />;
      })}
    </Container>
  );
};

export const Container = styled.div`
  &.wp-block-column {
    padding: 0.5rem;
    flex-grow: 1;
    min-width: 0;
    word-break: break-word;
    overflow-wrap: break-word;
    h2 {
      margin-top: 0;
    }
    @media (min-width: 782px) {
      flex-basis: 0;
      flex-grow: 1;
    }
    @media (max-width: 600px) {
      flex-basis: 100% !important;
    }
  }
`;
